import { Container } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import { colors } from 'styles/colors';

const Hero = () => {
    return (
        <section
            className="position-relative overflow-hidden"
            style={{
                background: colors.gradient.soft,
                padding: 'clamp(2.5rem, 5vw, 4rem) 0 clamp(2rem, 4vw, 3rem)',
                textAlign: 'center',
                borderBottomLeftRadius: '30px',
                borderBottomRightRadius: '30px',
                marginLeft: 25,
                marginRight: 25,
            }}
        >
            {/* Decorative elements */}
            <div style={{ position: 'absolute', top: '-80px', left: '-60px', width: '280px', height: '280px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(36,52,125,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />
            <div style={{ position: 'absolute', bottom: '-50px', right: '-40px', width: '220px', height: '220px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(38,162,171,0.08) 0%, transparent 70%)', pointerEvents: 'none' }} />
            <svg style={{ position: 'absolute', top: '30px', right: '8%', opacity: 0.1, pointerEvents: 'none' }} width="70" height="70" viewBox="0 0 70 70" fill="none">
                {[0, 18, 36, 54].map(x => [0, 18, 36, 54].map(y => <circle key={`${x}-${y}`} cx={x + 4} cy={y + 4} r="2" fill="#24347D" />))}
            </svg>
            <svg style={{ position: 'absolute', bottom: '40px', left: '6%', opacity: 0.08, pointerEvents: 'none' }} width="50" height="50" viewBox="0 0 50 50" fill="none">
                {[0, 18, 36].map(x => [0, 18, 36].map(y => <circle key={`${x}-${y}`} cx={x + 4} cy={y + 4} r="2" fill="#26A2AB" />))}
            </svg>
            {/* Floating ring */}
            <svg style={{ position: 'absolute', top: '25%', left: '12%', opacity: 0.08, pointerEvents: 'none' }} width="50" height="50" viewBox="0 0 50 50" fill="none">
                <circle cx="25" cy="25" r="20" stroke="#24347D" strokeWidth="2" />
            </svg>

            <Container className="position-relative" style={{ zIndex: 1 }}>
                {/* Pill badge */}
                <div
                    className="d-inline-flex align-items-center mb-4"
                    style={{
                        gap: '8px',
                        background: 'rgba(36,52,125,0.08)',
                        borderRadius: '50px',
                        padding: '8px 20px',
                        border: '1px solid rgba(36,52,125,0.1)',
                    }}
                >
                    <FeatherIcon icon="mail" style={{ width: '14px', height: '14px', color: colors.primary.darkBlue }} />
                    <span style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: colors.primary.darkBlue }}>
                        Contact
                    </span>
                </div>

                <h1
                    style={{
                        fontSize: 'clamp(2rem, 5vw, 3.2rem)',
                        fontWeight: 800,
                        color: colors.primary.darkBlue,
                        lineHeight: 1.2,
                        marginBottom: '16px',
                    }}
                >
                    Get in Touch with{' '}
                    <span style={{ color: colors.primary.teal }}>SalesTrackify</span>
                </h1>
                <p
                    style={{
                        fontSize: 'clamp(0.95rem, 1.8vw, 1.12rem)',
                        lineHeight: 1.7,
                        color: '#6b7280',
                        maxWidth: '580px',
                        margin: '0 auto',
                    }}
                >
                    Request a demo, ask about white-label options, or get help selecting the right setup for your team.
                </p>

                {/* Decorative line */}
                <div
                    style={{
                        width: '60px',
                        height: '3px',
                        borderRadius: '2px',
                        background: `linear-gradient(90deg, ${colors.primary.darkBlue}, ${colors.primary.teal})`,
                        margin: '28px auto 0',
                    }}
                />
            </Container>
        </section>
    );
};

export default Hero;
